import Box from '@mui/material/Box';
import { Outlet, createRootRoute, useNavigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { routeFor } from '../features/auth/routeFor';
import { AppNav } from '../features/layout/AppNav';
import { Footer } from '../features/layout/Footer';
import { useAuthStore } from '../stores/auth';

/** One page width everywhere (#171), with a 16px gutter on phones. */
export const PAGE_MAX_WIDTH = 1200;

function RootLayout() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { me, refresh, logout } = useAuthStore();

  useEffect(() => {
    if (me === undefined) void refresh();
  }, [me, refresh]);

  // Signed out → /login; prospect who hasn't accepted the terms → /terms;
  // non-admin on an admin page → home (#170).
  useEffect(() => {
    const to = routeFor(me, pathname);
    if (to) navigate({ to });
  }, [me, pathname, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppNav
        me={me}
        pathname={pathname}
        onNavigate={(to) => navigate({ to })}
        onSignOut={() => void logout()}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          maxWidth: PAGE_MAX_WIDTH,
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          py: 3,
        }}
      >
        <Outlet />
      </Box>
      {me ? <Footer onTerms={() => navigate({ to: '/terms' })} /> : null}
    </Box>
  );
}

export const Route = createRootRoute({ component: RootLayout });
